export default __webpack_public_path__ + "static/media/boarding-adoptar.34e88723.svg";